import { render, staticRenderFns } from "./bindMobile.vue?vue&type=template&id=618364c9&"
import script from "./bindMobile.vue?vue&type=script&lang=js&"
export * from "./bindMobile.vue?vue&type=script&lang=js&"
import style0 from "./bindMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports